export const TRANSLATION_ACTION_COPY = {
  edit: 'Edit',
  view: 'View',
  remove: 'Remove',
} as const;
